/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FleetFillsResponse } from '../models/FleetFillsResponse';
import type { FleetHistoryResponse } from '../models/FleetHistoryResponse';
import type { FleetPositionsResponse } from '../models/FleetPositionsResponse';
import type { FleetResponse } from '../models/FleetResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FleetService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List Fleet
     * Every candidate this account owns.
     *
     * ⚠ `principal: CurrentPrincipal` is not optional here and `tests/test_api_exposure.py` now fails
     * without it — which is the gap D59 left open and 79c recorded as *"nothing in the suite fails
     * when a route is added without `CurrentPrincipal`"*. This is the first route added since that
     * became false.
     * @returns FleetResponse Successful Response
     * @throws ApiError
     */
    public listFleet(): CancelablePromise<FleetResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/fleet',
        });
    }
    /**
     * List Fleet History
     * Every buy and sell across the account's candidates, newest first.
     *
     * 🔴 **This route takes no deployment id, which makes `owner_id` the only isolation.** The
     * predicate is inside `store.list_all_fills` rather than here, so there is no code path that
     * reads another account's rows before deciding they are not yours.
     *
     * ⚠ **Declared before `/fleet/{deployment_id}/fills` matters not at all** — the paths differ in
     * shape, not just in value — but `q` is deliberately optional rather than defaulted to `""`:
     * *no filter* and *filter on empty* are the same result here, and one of them is a lie about
     * what the operator asked for.
     * @returns FleetHistoryResponse Successful Response
     * @throws ApiError
     */
    public listFleetHistory({
        q,
    }: {
        q?: (string | null),
    }): CancelablePromise<FleetHistoryResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/fleet/fills',
            query: {
                'q': q,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Fleet Fills
     * Every buy and sell for one candidate.
     *
     * 🔴 **Authorisation is the `owner_id` join inside `store.list_fills`, not a check here.** The
     * `deployment_id` is client-supplied, so a route that read it and then filtered in Python would
     * be one refactor away from leaking another account's executions. Keeping the ownership predicate
     * in the query means there is no code path that reads the rows before deciding they are yours.
     *
     * ⚠ An unknown id and an unowned one both return an empty page rather than a 404 — a 404 that
     * distinguished them would confirm another account's candidate exists.
     * @returns FleetFillsResponse Successful Response
     * @throws ApiError
     */
    public listFleetFills({
        deploymentId,
    }: {
        deploymentId: number,
    }): CancelablePromise<FleetFillsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/fleet/{deployment_id}/fills',
            path: {
                'deployment_id': deploymentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Fleet Positions
     * Every position for one candidate, newest first — the fourth detail pane.
     *
     * 🔴 **Authorisation is the `owner_id` join inside `store.list_positions`, not a check here** —
     * the same argument as `list_fleet_fills`: the id is client-supplied, so keeping the ownership
     * predicate in the query means no code path reads the rows before deciding they are yours.
     *
     * ⚠ An unknown id and an unowned one both return an empty page rather than a 404.
     * @returns FleetPositionsResponse Successful Response
     * @throws ApiError
     */
    public listFleetPositions({
        deploymentId,
    }: {
        deploymentId: number,
    }): CancelablePromise<FleetPositionsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/fleet/{deployment_id}/positions',
            path: {
                'deployment_id': deploymentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
